<template>
	<div>
		<Card dis-hover title="订单开票">
			<Form :model="searchData" inline :label-width="90">
				<FormItem label="渠道">
					<Input v-model="searchData.platform" placeholder="请输入渠道" clearable style="width: 180px" />
				</FormItem>
				<FormItem label="车队">
					<Input v-model="searchData.companyName" placeholder="请输入车队" clearable style="width: 180px" />
				</FormItem>
				<FormItem label="订单时间">
					<DatePicker v-model="searchData.transRange" type="datetimerange" format="yyyy-MM-dd HH:mm:ss"
						placeholder="订单发生时间范围" style="width: 300px" @on-change="handleTransRangeChange" />
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSearch">查询</Button>
					<Button style="margin-left: 10px" @click="handleReset">重置</Button>
				</FormItem>
			</Form>
			<Form>
				<FormItem>
					<Select v-model="searchData.invoiceStatus" placeholder="开票状态" style="width: 180px">
						<Option v-for="item in ['未开票', '开票中', '已开票', '已开票撤销']" :key="item" :value="item">{{ item }}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Card>

		<Card style="margin-top: 20px;">
			<Table :columns="columns" :data="tableData" :loading="loading" border></Table>
			<Page class="page" :total="total" :current="currentPage" :page-size="pageSize" show-total show-elevator
				show-sizer @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange"></Page>
		</Card>
	</div>
</template>

<script>
import { render } from 'less';
import { Select } from 'view-design';

export default {
	name: 'invoice',
	data() {
		return {
			searchData: {
				platform: '',
				companyName: '',
				transRange: [],
			},
			loading: false,
			tableData: [],
			total: 0,
			currentPage: 1,
			pageSize: 20,
			columns: [
				{ type: 'selection', width: 50, align: 'center' ,render: (h, params) => {
					if (params.row.invoice_status === '已开票' || params.row.invoice_status === '开票中') {
						return h('span', {
							style: {
								color: '#999',
								cursor: 'not-allowed'
							}
						}, '不可选');
					} else {
						return h('Checkbox', {
							props: {
								value: params.row.selected || false
							},
							on: {
								'input': (checked) => {
									params.row.selected = checked;
								}
							}
						});
					}
				}},
				{ title: '订单号', key: 'order_no', align: 'center', minWidth: 190, ellipsis: true },
				{ title: '油品', key: 'oilName', align: 'center', minWidth: 40, ellipsis: true },
				{ title: '开票数量（L或KG）', key: 'litre_num', align: 'center', minWidth: 80, ellipsis: true, tooltip: true },
				{ title: '车队', key: 'company_name', align: 'center', minWidth: 110, ellipsis: true, tooltip: true },
				{ title: '渠道', key: 'platform', align: 'center', minWidth: 60, ellipsis: true, tooltip: true },
				{ title: '车队结算金额（元）', key: 'settlementAmount', align: 'center', minWidth: 70, ellipsis: true, tooltip: true },
				{ title: '站点成本（元）', key: 'costAmount', align: 'center', minWidth: 70, ellipsis: true, tooltip: true },
				{ title: '利润（元）', key: 'discountAmount', align: 'center', minWidth: 50, ellipsis: true, tooltip: true },
				{ title: '下单时间', key: 'create_time', align: 'center', minWidth: 170, ellipsis: true, tooltip: true },
			]
		}
	},
	methods: {
		normalizeRangeEndToDay(range) {
			if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
				return []
			}
			const start = new Date(range[0])
			const end = new Date(range[1])
			if (isNaN(start.getTime()) || isNaN(end.getTime())) {
				return []
			}
			end.setHours(23, 59, 59, 999)
			return [start, end]
		},
		handleTransRangeChange() {
			const normalized = this.normalizeRangeEndToDay(this.searchData.transRange)
			this.searchData.transRange = normalized
		},

		formatDateTime(date, isEnd = false) {
			const d = new Date(date)
			if (isEnd) d.setHours(23, 59, 59, 999)
			const year = d.getFullYear()
			const month = String(d.getMonth() + 1).padStart(2, '0')
			const day = String(d.getDate()).padStart(2, '0')
			const hours = String(d.getHours()).padStart(2, '0')
			const minutes = String(d.getMinutes()).padStart(2, '0')
			const seconds = String(d.getSeconds()).padStart(2, '0')
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
		},
		buildParams() {
			const params = {
				page: this.currentPage,
				page_size: this.pageSize
			}
			if (this.searchData.platform) params.platform = this.searchData.platform.trim()
			if (this.searchData.companyName) params.companyName = this.searchData.companyName.trim()

			if (Array.isArray(this.searchData.transRange) && this.searchData.transRange.length === 2 && this.searchData.transRange[0]) {
				params.start_trans_time = this.formatDateTime(this.searchData.transRange[0], false)
				// 结束时间设置为当天的23:59:59，确保包含整天的交易
				params.end_trans_time = this.formatDateTime(this.searchData.transRange[1], true)
			}
			return params
		},
		async getList() {
			this.loading = true
			try {
				const res = await this.$commonFun.postProxy('admin/finance/getOrderForInvoice', this.buildParams())
				this.$commonFun.dealApiResult(res, () => {
					this.tableData = res.data || []
					this.total = Number(res.count || 0)
				})
			} catch (e) {
				console.error('获取订单发票列表失败:', e)
			} finally {
				this.loading = false
			}
		},
		handleSearch() {
			this.currentPage = 1
			this.getList()
		},
		handleReset() {
			this.searchData = {
				platform: '',
				companyName: '',
				transRange: [],
			}
			this.currentPage = 1
			this.getList()
		},
		handlePageChange(page) {
			this.currentPage = page
			this.getList()
		},
		handlePageSizeChange(size) {
			this.pageSize = size
			this.currentPage = 1
			this.getList()
		}
	},
	mounted() {
		this.getList()
	}
}
</script>

<style scoped lang="less">
.page {
	margin-top: 20px;
	text-align: right;
}
</style>
